// extracted by mini-css-extract-plugin
module.exports = {"positionIndicatorWrapper":"_64e81cd7","positionIndicator":"_75839884"};